<template>
  <AppHeader />
  <main :class="{ 'main--transitioning': transitioning }">
    <router-view />
  </main>
  <AppFooter />
  <!--
    Hidden for now — the site isn't setting any cookies yet (only
    debugProvider in main.ts, which doesn't send/store anything), so the
    banner isn't legally required at this point. Re-enable by uncommenting
    once real tracking (e.g. Meta Pixel) actually gets wired in.
  -->
  <!-- <CookieConsentModal /> -->
</template>

<script setup lang="ts">
// Re-import when CookieConsentModal is uncommented below.
// import CookieConsentModal from "@/components/CookieConsentModal.vue";
import AppFooter from "@/components/layout/AppFooter.vue";
import AppHeader from "@/components/layout/AppHeader.vue";
import { onMounted, onUnmounted, ref } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();
const transitioning = ref(false);
let stopBeforeEach: (() => void) | undefined;
let stopAfterEach: (() => void) | undefined;

onMounted(() => {
  stopBeforeEach = router.beforeEach((to, from, next) => {
    if (to.path !== from.path) transitioning.value = true;
    next();
  });
  stopAfterEach = router.afterEach(() => {
    requestAnimationFrame(() => {
      transitioning.value = false;
    });
  });
});

onUnmounted(() => {
  stopBeforeEach?.();
  stopAfterEach?.();
});
</script>

<style scoped>
@layer kapish.components {
  main {
    transition: opacity var(--duration-fast, 150ms) var(--ease-out, ease-out);
  }

  .main--transitioning {
    opacity: 0;
  }
}
</style>
